import api from "./api-manager";

const baseURL = "https://www.googleapis.com";

const { REACT_APP_API_A39, REACT_APP_RMP_APP_ID } = process.env;

export default {
  async getGoogleUserInfo(params) {
    return api.get(`/oauth2/v3/userinfo?access_token=${params.token}`, {
      baseURL,
      headers: {
        "Content-Type": `application/json`,
      },
    });
  },
  /**
   * get Google Sheets data from database
   * @param {*} params
   * @returns
   */
  async getGoogleSheetsList(params) {
    return api.post(
      `/v1/google/search-google-sheets`,
      {
        refreshToken: params.refreshToken,
        googleAccount: params.googleAccount,
        spreadsheetUrl: params.spreadsheetUrl,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get access_token by code
   * @param {*} params
   * @returns
   */
  async getGoogleExchangeToken(params) {
    return api.post(
      `/v1/google/login/exchange-token`,
      {
        authCode: params.code,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save google account to database
   * @param {*} params
   * @returns
   */
  async setGoogleAccount(params) {
    return api.post(
      `/v1/google/save-account`,
      {
        tokens: params.tokens,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google account from database
   * @param {*} params
   * @returns
   */
  async getGoogleAccount(params) {
    return api.post(
      `/v1/google/get-account`,
      {
        googleAccount: params.googleAccount,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save Google Sheets setting to database
   * @param {*} params
   * @returns
   */
  async setGoogleSheetsSetting(params) {
    return api.post(
      `/v1/google/save-setting-fb-lead-form`,
      {
        settingId: params.settingId,
        googleAccount: params.googleAccount,
        spreadsheetUrl: params.spreadsheetUrl,
        refreshToken: params.refreshToken,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google ads lead form
   * @param {*} params
   * @returns
   */
  async getGoogleAdsLeadForm(params) {
    return api.post(
      `/v1/google/get-lead-form`,
      {
        appReserve: params.appReserve,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save google ads lead form setting to database
   * @param {*} params
   * @returns
   */
  async setGoogleAdsLeadFormSetting(params) {
    return api.post(
      `/v1/google/save-setting-gg-lead-form`,
      {
        appReserve: params.appReserve,
        settingId: params.settingId,
        formSetting: params.formSetting,
        assetId: params.assetId,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save Google Sheets setting to database
   * @param {*} params
   * @returns
   */
  async setGoogleSheetsGGLeadsSetting(params) {
    return api.post(
      `/v1/google/save-setting-gsheet-lead-form`,
      {
        settingId: params.settingId,
        googleAccount: params.googleAccount,
        spreadsheetUrl: params.spreadsheetUrl,
        refreshToken: params.refreshToken,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get Google lead form setting from database to show all connections
   * @param {*} params
   * @returns
   */
  async getAllGoogleLeadFormSettings(params) {
    return api.post(
      `/v1/google/get-all-lead-form-setting`,
      { appReserve: params.appReserve },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * switch lead form status
   * @param {*} params
   * @returns
   */
  async switchGoogleLeadFormStatus(params) {
    return api.post(
      `/v1/google/swich-lead-form-status`,
      {
        googleLeadSettingId: params.googleLeadSettingId,
        status: params.status,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * delete leadform setting
   * @param {*} params
   * @returns
   */
  async archiveGoogleLeadFormSetting(params) {
    return api.post(
      `/v1/google/archive-lead-form-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google ads setting
   * @param {*} params
   * @returns
   */
  async getGoogleAdsSetting(params) {
    return api.post(
      `/v1/google/get-google-ads-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google sheets setting
   * @param {*} params
   * @returns
   */
  async getGoogleSheetsSetting(params) {
    return api.post(
      `/v1/google/get-google-sheets-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get rcrm setting
   * @param {*} params
   * @returns
   */
  async getGoogleLeadCRMSetting(params) {
    return api.post(
      `/v1/google/get-crm-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google lead form setting
   * @param {*} params
   * @returns
   */
  async getGoogleLeadFormSetting(params) {
    return api.post(
      `/v1/google/get-google-lead-form-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get lead steps with crm conversion
   * @param {*} params
   * @returns
   */
  async getLeadSteps(params) {
    return api.post(
      `/v1/google/get-lead-step`,
      {
        app_id: REACT_APP_RMP_APP_ID,
        lang: params.lang,
        lead_pipeline: params.lead_pipeline_id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google sheets conversion value
   * @param {*} params
   * @returns
   */
  async getGoogleSheetsOfflineConversionsValue(params) {
    return api.get(`/v1/google/gsheet/conversions/get-default-value`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  /**
   * set google sheets conversion value
   * @params {*} params
   * @returns
   */
  async setGoogleSheetsOfflineConversionsValue(params) {
    return api.post(
      `/v1/google/gsheet/conversions/default-value`,
      {
        pipelineSteps: params.pipelineSteps,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google sheets offline conversions last sent time
   * @param {*} params
   * @returns
   */
  async getGoogleSheetsOfflineConversionsLastSent(params) {
    return api.get(`/v1/google/gsheet/conversions/last-sent`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  /**
   * update google sheets status
   * @param {*} params
   * @returns
   */
  async updateGGLeadFormSettingErrorStatus(params) {
    return api.post(
      `/v1/google/update-error-status`,
      {
        googleLeadSettingId: params.googleLeadSettingId,
        connectedApp: params.connectedApp,
        errorMessage: params.errorMessage,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
};
